document.addEventListener("DOMContentLoaded", function() {
  // Chọn tất cả các biểu tượng mở rộng trong menu
  const dropdownIcons = document.querySelectorAll(".navbar-nav-canvas .bi-chevron-down");

  dropdownIcons.forEach(icon => {
    icon.addEventListener("click", function(event) {
      event.preventDefault();

      // Tìm menu con trực tiếp bên dưới biểu tượng được nhấn (nếu tồn tại)
      const dropdownMenu = icon.closest("li").querySelector("ul");

      // Kiểm tra nếu `dropdownMenu` tồn tại
      if (!dropdownMenu) return;

      // Kiểm tra trạng thái hiện tại của menu
      const isMenuOpen = dropdownMenu.classList.contains("show");

      // Nếu menu đang mở thì đóng lại, nếu không thì mở
      if (isMenuOpen) {
        dropdownMenu.style.height = "0";
        dropdownMenu.classList.remove("show");
      } else {
        dropdownMenu.style.height = dropdownMenu.scrollHeight + "px";
        dropdownMenu.classList.add("show");
      }
    });
  });

  // Đặt height thành 'auto' sau khi mở hoàn tất để giữ layout khi nội dung menu thay đổi
  document.querySelectorAll(".site-nav--has-dropdown ul").forEach(menu => {
    menu.addEventListener("transitionend", () => {
      if (menu.classList.contains("show")) {
        menu.style.height = "auto";
      }
    });
  });
});
